import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  addBanner,
  checkIfDuplicateExists,
} from "../../firebase/fireStoreServices";
import BulkUploadData from "./BulkUploadData";

export default function BannerAdminForm() {
  const [bannerData, setBannerData] = useState({
    title: "",
    subTitle: "",
    image: "",
  });

  const handleChange = (event) => {
    setBannerData({ ...bannerData, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const isDuplicate = await checkIfDuplicateExists("banners", {
        title: bannerData.title,
        image: bannerData.image,
      });
      if (isDuplicate) {
        alert("This banner is already present in the database!");
        return;
      } else {
        await addBanner(bannerData);
        alert("Banner added successfully!");
        setBannerData({
          title: "",
          subTitle: "",
          image: "",
        });
      }
    } catch (error) {
      console.error("Error adding Banner: ", error);
      alert("Failed to add Banner");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{ mt: 2, p: 4, bgcolor: "#f9f9f9", borderRadius: 3, boxShadow: 3 }}
      >
        <Typography variant="h5" mb={3} fontWeight="bold" textAlign="center">
          Banner Admin Form
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Title"
                name="title"
                fullWidth
                value={bannerData.title}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Sub Title"
                name="subTitle"
                fullWidth
                value={bannerData.subTitle}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Image URL"
                name="image"
                fullWidth
                value={bannerData.image}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} textAlign="center">
              <Button type="submit" variant="contained" color="secondary">
                Add Banner
              </Button>
            </Grid>
          </Grid>
        </form>
        <Divider sx={{ mt: 3 }} />
        <BulkUploadData collectionName="banners" uploadService={addBanner} />
      </Box>
    </Container>
  );
}
